import SectionTitle from './SectionTitle';

export default function DocumentNotes({
  notes,
  specialRequirements,
}: {
  notes: string[];
  specialRequirements: string | null;
}) {
  return (
    <div className="px-6 md:px-9 mt-8 space-y-7">
      {specialRequirements && (
        <div>
          <SectionTitle>Special Requirements</SectionTitle>
          <p className="mt-3 text-sm text-ink-600 leading-relaxed whitespace-pre-line">
            {specialRequirements}
          </p>
        </div>
      )}

      <div>
        <SectionTitle>Notes</SectionTitle>
        <div className="mt-3 space-y-2">
          {notes.map((n, i) => (
            <div key={i} className="flex items-start gap-2.5">
              <i className="ri-information-line text-ink-300 text-sm mt-0.5 shrink-0" />
              <p className="text-xs text-ink-500 leading-relaxed">{n}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}